import * as Types from '../types';

export const getProductDomainData = payload => ({
    type        : Types.LOAD_PRODUCT_DOMAIN_DATA,
    payload
});

export const changeSorting = payload => ({
    type        : Types.CHANGE_SORTING,
    payload
});

export const addFilter = payload => ({
    type        : Types.ADD_FILTER,
    payload
});

export const removeFilter = payload => ({
    type        : Types.REMOVE_FILTER,
    payload
});

export const changeCategoryFilter = payload => ({
    type        : Types.CHANGE_CATEGORY_FILTER,
    payload
});

export const changePage = payload => ({
    type        : Types.CHANGE_PAGE,
    payload
});

export const addProductToCart = payload => ({
    type        : Types.ADD_PRODUCT_TO_CART,
    payload
});

export const changeProductInCart = payload => ({
    type        : Types.CHANGE_PRODUCT_IN_CART,
    payload
});

export const removeProductFromCart = payload => ({
    type        : Types.REMOVE_PRODUCT_FROM_CART,
    payload
});